exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_container__KRYx2{display:flex;width:100%;align-items:flex-end}.style_selectedIcon__sA0M_{top:.2rem;position:relative;padding-right:.5rem}.style_outerContainer__2cu41{width:100%}.style_innerContainer__3mocN{overflow:hidden;text-overflow:ellipsis}.style_actions__1dJnI{margin-left:.5rem}.style_select__3VB4M{flex:1 1 auto}", ""]);

// exports
exports.locals = {
	"container": "style_container__KRYx2",
	"selectedIcon": "style_selectedIcon__sA0M_",
	"outerContainer": "style_outerContainer__2cu41",
	"innerContainer": "style_innerContainer__3mocN",
	"actions": "style_actions__1dJnI",
	"select": "style_select__3VB4M"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/form/AccountSelect/style.less
// module id = 1964
// module chunks = 8